import { getProductOptionUnitCost } from '../../_utils/getProductOptionUnitCost'
import { ProductVariant } from '@pageFeatures/design/designUpload/types'

const getProductOptionSummary = ({
  productOption,
  locale,
}: {
  productOption: ProductVariant
  locale: string
}): { name: string; value: string | number }[] => {
  const productOptions: { name: string; value: string | number }[] =
    productOption?.optionsValues?.map((x) => ({
      name: x.option_display_name,
      value: x.label,
    })) || []

  const unitCost = {
    name: 'Unit Cost',
    value: getProductOptionUnitCost({ productOption, locale }),
  }

  const isValidValue = (optionValue: any) =>
    Boolean(optionValue) &&
    (typeof optionValue === 'string' || typeof optionValue === 'number')

  return [...productOptions, unitCost].filter((x) => isValidValue(x.value))
}

export { getProductOptionSummary }
